import { Person } from '@enview/interface/types/Person';
import { CURRENT_SESSION_FILTER } from '../../api/jurisdiction';
import STATES from '../../helpers/states';

// Find persons jurisdictions to get session options for filter
export const getJurisdictions = (person: Person): string[] => {
  const jurisdictions: string[] = [];
  if (person.electedPositions) {
    person.electedPositions.forEach((position) => {
      if (!jurisdictions.includes(position.jurisdiction.abbreviation))
        jurisdictions.push(position.jurisdiction.abbreviation);
    });
  }
  return jurisdictions;
};

export const getFiltersFromSelectedSessions = (
  selectedSessions: string[],
  jurisdictions: string[],
): { sessionFilters: string[]; jurisdictionFilters: string[] } => {
  const sessionFilters: string[] = [];
  const jurisdictionFilters: string[] = [];

  // add jurisdictions to find current sessions if "Current Sessions" filter is chosen
  selectedSessions.forEach((session) => {
    if (session === CURRENT_SESSION_FILTER) {
      sessionFilters.push(session);
      jurisdictions.forEach((jur) => jurisdictionFilters.push(jur));
    }

    jurisdictions.forEach((jur) => {
      const jurisdiction = STATES[jur.toUpperCase()];
      if (session.includes(jurisdiction)) {
        const sessionFilter = session.replace(jurisdiction, '').trim();
        jurisdictionFilters.push(jur);
        sessionFilters.push(sessionFilter);
      }
    });
  });
  return { sessionFilters, jurisdictionFilters };
};
